import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
    return (
        <div>
            <div className="lp-topbar">
                <div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div>
                <Link to="/login" className="lp-login-btn">Login</Link>
            </div>

            <section className="lp-hero">
                <div className="lp-container">
                    <h1>Simple CRM for ESL Schools</h1>
                    <p>
                        aistCRM is a simple and affordable management system designed specifically 
                        for ESL schools working with F-1 students.
                    </p>
                    <p>
                        Manage student lifecycle, documents, billing, and internal processes 
                        without expensive enterprise software or complicated setup.
                    </p>

                    <Link to="/register" className="lp-button">
                        Try It Yourself
                    </Link>
                    <div className="lp-sub-cta">
                        No credit card required · First month free
                    </div>
                </div>
            </section>

            <section className="lp-section lp-white">
                <div className="lp-container">
                    <h2>Our Goal</h2>
                    <p>
                        Our goal is to simplify student management, reduce administrative workload,
                        and give schools full visibility into their operations and financial performance.
                    </p>
                    <p>
                        We help schools grow without increasing operational complexity.
                    </p>
                </div>
            </section>

            <section className="lp-features lp-gray">
                <div className="lp-container">
                    <h2>Core Features</h2>

                    <div className="lp-grid">

                        <div className="lp-card">
                            <h3>Student Lifecycle & Compliance</h3>
                            <ul>
                                <li>Status-based student tracking</li>
                                <li>Document & I-20 management</li>
                                <li>Complete student history</li>
                            </ul>
                        </div>

                        <div className="lp-card">
                            <h3>Billing & Financial Management</h3>
                            <ul>
                                <li>One-time & recurring invoices</li>
                                <li>Payment tracking & outstanding balance</li>
                                <li>Revenue reports</li>
                            </ul>
                        </div>

                        <div className="lp-card">
                            <h3>Roster & Academic Tracking</h3>
                            <ul>
                                <li>Active student roster</li>
                                <li>Program assignments</li>
                                <li>Individual terms & classes set-up</li>
                            </ul>
                        </div>

                        <div className="lp-card">
                            <h3>Internal Operations & Agents</h3>
                            <ul>
                                <li>Policy management</li>
                                <li>Agent tracking</li>
                                <li>Internal chat</li>
                            </ul>
                        </div>

                        <div className="lp-card">
                            <h3>Team Collaboration & Roles</h3>
                            <ul>
                                <li>Multi-School Support</li>
                                <li>Role-based permissions</li>
                                <li>Internal calendar</li>
                            </ul>
                        </div>

                        <div className="lp-card">
                            <h3>Personalized Support & Pricing</h3>
                            <ul>
                                <li>Fast, Direct Support</li>
                                <li>Tailored Solutions</li>
                                <li>Flexible Pricing & Custom Discounts</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </section>

            <section className="lp-section lp-white">
                <div className="lp-container">
                    <h2>Pricing</h2>
                    <p>
                        Transparent pricing designed for small and growing ESL schools.
                        Always less than <strong>$1 per student / month</strong>.
                    </p>

                    <div className="lp-pricing-grid">

                        <div className="lp-price-card">
                            <h3>Starter</h3>
                            <div className="lp-price">$29<small> / month</small></div>
                            <ul>
                                <li>Up to 30 active students</li>
                                <li>Up to 10 staff members</li>
                                <li>All core features included</li>
                            </ul>
                            <Link to="/register" className="lp-button">
                                Start Free
                            </Link>
                        </div>

                        <div className="lp-price-card lp-popular">
                            <h3>Growth</h3>
                            <div className="lp-price">$39<small> / month</small></div>
                            <ul>
                                <li>Up to 50 active students</li>
                                <li>Up to 20 staff members</li>
                                <li>All core features included</li>
                            </ul>
                            <Link to="/register" className="lp-button">
                                Start Free
                            </Link>
                        </div>

                        <div className="lp-price-card">
                            <h3>Professional</h3>
                            <div className="lp-price">$69<small> / month</small></div>
                            <ul>
                                <li>Up to 100 active students</li>
                                <li>Up to 30 staff members</li>
                                <li>All core features included</li>
                            </ul>
                            <Link to="/register" className="lp-button">
                                Start Free
                            </Link>
                        </div>

                    </div>
                </div>
            </section>

            <section className="lp-cta">
                <div className="lp-container">
                    <h2>Ready to simplify your school management?</h2>
                    <Link to="/register">
                        Try It Yourself
                    </Link>
                    <div className="lp-sub-cta">
                        No credit card required · First month free
                    </div>
                </div>
            </section>

            <section className="lp-section lp-gray">
                <div className="lp-container">
                    <h2>Contact Us</h2>
                    <p style={{marginBottom: '30px'}}>
                        Have questions about aistCRM or want to see if it’s a good fit for your ESL school?
                        Send us an email!
                    </p>

                    <p><a href="mailto:support@aistcrm.com" className="lp-button">
                        Email Support
                    </a></p>

                    <p style={{marginTop: '15px', color: '#666', fontSize: '14px'}}>
                        support@aistcrm.com
                    </p>
                </div>
            </section>

            <footer className='lp-white'>
                <div className="lp-footer-links">
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                © 2026 aistCRM. All rights reserved.
            </footer>
        </div>
    );
};

export default LandingPage;
